import $ from 'jquery';
import { getDevCenterDataStore } from '../app/store';
import { getPartnerName } from '../lhs/reducers/configuration-reducer';
// show div based on Id
function showDivBasedOnId(id)
{
    var element = document.getElementById(id);
    if(element){
        element.style.display = "block";
    }
}

// show div based on Id
function clickDivBasedOnId(id)
{
    var element = document.getElementById(id);
    if(element){
        element.click();
    }
}

// show div based on Id
function clickDivBasedOnClass(className)
{
    var elements = document.getElementsByClassName(className);

        for (var i = 0; i < elements.length; i++) {
        elements[i].click();
        }
}
//hide div based on Id
function hideDivBasedOnId(id)
{
    var element = document.getElementById(id);
    if(element){
        element.style.display = "none";
    }
}

function setDisplayFlexBasedOnId(id){
    var element = document.getElementById(id);
    if(element){
        element.style.display = "flex";
    }
}

function setDisplayVisibleBasedOnId(id){
    var element = document.getElementById(id);
    if(element){
        element.style.visibility = "visible";
    }
}

function setDisplayHiddenBasedOnId(id){
    var element = document.getElementById(id);
    if(element){
        element.style.visibility = "hidden";
    }
}

function showDivBasedOnClassName(className)
{
    var elements = document.getElementsByClassName(className);
    
    if(elements != null)
    {
        
        for (var i = 0; i < elements.length; i ++) {
            elements[i].style.display = 'block';
            }
    }
}


function hideDivBasedOnClassName(className)
{
    var elements = document.getElementsByClassName(className);
    if(elements != undefined)
    {
        for (var i = 0; i < elements.length; i ++) {
            elements[i].style.display = 'none';
            }
    }      
}

function isDefaultSite()
{
    var partnerName = getPartnerName();
    if(partnerName == 'cybs'){
        return true;
    }
    return false;
}
function setEndOfContenteditable(contentEditableElement)
{
    var range,selection;
    if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
    {
        range = document.createRange();//Create a range (a range is a like the selection but invisible)
        range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
        range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
        selection = window.getSelection();//get the selection object (allows you to change selection)
        selection.removeAllRanges();//remove any selections already made
        selection.addRange(range);//make the range you have just created the visible selection
    }
}

function getLanguageDetails()
{
    var languages = [
        {'label':'Live Console','value':'Live Console'},
        {'label': 'Java','value': 'Java'},
        {'label': 'C#','value': 'Cs'},
        {'label': 'PHP','value': 'Php'},
        {'label': 'Node','value': 'Js'},
        {'label': 'Python','value': 'Py'},
        {'label': 'Ruby','value': 'Rb'}
    ];
    return languages;
}


function setJsTreePath()
{
    const homePage = require('../dist/json/config.json');
    var pathPrefix = (homePage.homepage == "" ? '/' : homePage.homepage)
    var prefix = 'url(' + pathPrefix +'/images/treeview/';
    var jsTreePath = '';
    if(!isDefaultSite())
    {
        jsTreePath = prefix +'default/';
    }
    else
    {
        var hostName = encodeURI(window.location.hostname);
        hostName = hostName.replace(".","-");
        jsTreePath = prefix + hostName +'/';
    }
    $('.rct-icons-fa5 .rct-icon-uncheck::before').css("content", jsTreePath + 'checkbox-empty.svg)');
    $('.rct-icons-fa5 .rct-icon-check::before').css("content", jsTreePath + 'checkbox-filled.svg)');
    $('.rct-icons-fa5 .rct-icon-half-check::before').css("content", jsTreePath + 'checkbox-indeterminate.svg)');
}

function createClass(name,rules){
    var style = document.createElement('style');
    document.head.appendChild(style);
    style.sheet.insertRule(name+"{"+rules+"}",0);
}




export default showDivBasedOnId;
export {showDivBasedOnId,hideDivBasedOnId, setDisplayFlexBasedOnId, setEndOfContenteditable,getLanguageDetails,showDivBasedOnClassName,hideDivBasedOnClassName,clickDivBasedOnId,clickDivBasedOnClass,setDisplayVisibleBasedOnId,setDisplayHiddenBasedOnId,isDefaultSite,setJsTreePath,createClass};